
export class DeclIrSefParamsDTO {

  constructor(
    public cdCentrus?: number,
    public tpEmpFin?:  number,
    public nrContrato?:  number,
    public dtLancto?:  number
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/DTO/declIrSef-árams.DTO.ts